import { Box } from '@mui/material';
import { IconButtonAnimate } from '~/components/animate';
import SvgIconStyle from '~/components/SvgIconStyle';
import { styles } from './styles';
import Image from '~/components/Image';

type Props = {
  isCollapse?: boolean;
  onToggleCollapse: VoidFunction;
  collapseClick: boolean;
};

export default function CollapseButton({ isCollapse, onToggleCollapse, collapseClick }: Props) {
  return (
    <IconButtonAnimate onClick={onToggleCollapse} sx={styles.collapseButtonContainer}>
      <Box
        sx={{
          lineHeight: 0,
          transition: (theme) =>
            theme.transitions.create('transform', {
              duration: theme.transitions.duration.shorter,
            }),
          ...(collapseClick &&
            !isCollapse && {
              transform: 'rotate(180deg)',
            }),
        }}
      >
        {isCollapse ? (
          <Image
            src="/icons/iconly/light/collapse_button_background.svg"
            alt="collapsed button"
            sx={styles.collapseButton}
          />
        ) : (
          <SvgIconStyle src="/icons/iconly/light/arrow_left.svg" sx={styles.icon} />
        )}
      </Box>
    </IconButtonAnimate>
  );
}
